'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import { buildConsentConfig } from '@app/lib/consent/config';
import { disableReplay, enableReplay } from '@app/lib/consent/sentryReplay';
import { DEFAULT_CONSENT, type ConsentState } from '@app/lib/consent/types';
interface ConsentContextValue {
  /** Accepted categories, kept in sync with the banner. */
  categories: ConsentState;
  /** Reopen the preferences dialog (used by the footer link). */
  openSettings: () => void;
}
const ConsentContext = createContext<ConsentContextValue>({
  categories: DEFAULT_CONSENT,
  openSettings: () => {}
});

/** Read accepted categories from the consent banner for tracker gating. */
export function useConsent() {
  return useContext(ConsentContext);
}
export function ConsentProvider(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const [categories, setCategories] = useState(DEFAULT_CONSENT);
  const started = useRef(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const next = {
        necessary: true,
        analytics: CookieConsent.acceptedCategory("analytics"),
        monitoring: CookieConsent.acceptedCategory("monitoring"),
        support: CookieConsent.acceptedCategory("support")
      };
      setCategories(next);
      if (next.monitoring) {
        enableReplay();
      } else {
        disableReplay();
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const sync = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (started.current) {
        return;
      }
      started.current = true;
      CookieConsent.run(buildConsentConfig(sync));
    };
    t3 = [sync];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  const openSettings = _temp;
  let t4;
  if ($[3] !== categories) {
    t4 = {
      categories,
      openSettings
    };
    $[3] = categories;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t4) {
    t5 = <ConsentContext.Provider value={t4}>{children}</ConsentContext.Provider>;
    $[5] = children;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp() {
  CookieConsent.showPreferences();
}